module.exports = __webpack_public_path__ + "static/media/objects2_27.1b7630c1.svg";